import React from 'react';

export default function ErrorScreen() {
  return (
    <p style={{ marginTop: '150px', textAlign: 'center' }}>
      Oops! Something get wrong. Please, try again.
    </p>
  );
}
